import { type ReactNode, memo } from "react";

import { Flexbox } from "../../core/components";
import { useModal } from "../../core/hooks";
import { CreateGroupModal } from "../../groups/components/CreateGroupModal";
import { CreateGroupContainerV2 } from "../../groups/containers";
import { LensSourceTypesContainer } from "../../lens-source/container";
import { LensSourcesPaginationProvider } from "../../lens-source/context";

import { dashboardStyle } from "./Dashboard.styles";
import { DashboardTabs } from "./DashboardTabs";
import { TitlePane } from "./TitlePane";

interface DashboardProps {
    isOrganizationNotSelected: boolean;
    children: ReactNode;
}

export const Dashboard = memo<DashboardProps>(({ isOrganizationNotSelected }) => {
    const [createLensGroupModalProps, showCreateLensGroupModal] = useModal(false);

    return (
        <Flexbox flexDirection="column" className={dashboardStyle}>
            <LensSourceTypesContainer>
                {({ types }) => (
                    <LensSourcesPaginationProvider types={types}>
                        <TitlePane onNewLensGroup={showCreateLensGroupModal} />
                        <DashboardTabs onNewLensGroup={showCreateLensGroupModal} loading={isOrganizationNotSelected} />
                        <CreateGroupContainerV2>
                            {({ createGroup }) => (
                                <CreateGroupModal
                                    {...createLensGroupModalProps}
                                    onCreate={createGroup}
                                    showLenses={true}
                                />
                            )}
                        </CreateGroupContainerV2>
                    </LensSourcesPaginationProvider>
                )}
            </LensSourceTypesContainer>
        </Flexbox>
    );
});
